"use client";
import { getPaymentMethods } from "@/shared/config/blockchain/helpers";
import {
  CryptoCurrencies,
  CryptoCurrencyID,
  PolAddress,
} from "@/shared/constants";
import { useWeb3State } from "@/web3/context";
import { ZeroAddress } from "ethers";
import { useMemo } from "react";
import { ThemedIcon } from "../../Icon";
import Image from "next/image";
import TurboIcon from "@/assets/icons/turbo.png";
import { twMerge } from "tailwind-merge";

const IconByChain = {
  [CryptoCurrencyID.ETH]: (
    <ThemedIcon className="mr-1 w-4 h-4" iconName={CryptoCurrencies.Ether} />
  ),
  [CryptoCurrencyID.POL]: (
    <ThemedIcon className="mr-1 w-4 h-4" iconName={CryptoCurrencies.POL} />
  ),
  [CryptoCurrencyID.WPOL]: (
    <ThemedIcon className="mr-1 w-4 h-4" iconName={CryptoCurrencies.WPOL} />
  ),
  [CryptoCurrencyID.WETH]: (
    <ThemedIcon className="mr-1 w-4 h-4" iconName={CryptoCurrencies.Weth} />
  ),
  [CryptoCurrencyID.USDT]: (
    <ThemedIcon className="mr-1 w-4 h-4" iconName={CryptoCurrencies.USDT} />
  ),
  [CryptoCurrencyID.TURBO]: (
    <Image
      src={TurboIcon.src}
      alt="Turbo"
      width={16}
      height={16}
      className={twMerge("mr-1 w-4 h-4")}
    />
  ),
};

const usePaymentMethods = (onlyERC20Support = false) => {
  const { chainId } = useWeb3State();

  return useMemo(() => {
    const paymentMethods = getPaymentMethods(chainId);

    if (!paymentMethods) return;

    const payments = Object.values(paymentMethods).map((paymentMethod) => ({
      label: (
        <span className="flex flex-row items-center text-body-3 font-bold mr-2">
          {IconByChain[paymentMethod.id]} {paymentMethod.label}
        </span>
      ),
      value: paymentMethod.tokenAddress,
    }));

    if (!onlyERC20Support) return payments;

    return payments.filter(
      (payment) => ![ZeroAddress, PolAddress].includes(payment.value),
    );
  }, [chainId, onlyERC20Support]);
};

export default usePaymentMethods;
